import React from 'react';
import clsx from 'clsx';

export interface OrderSuspendedAlertProps {
  suspensionMessage?: string;
  showWhatNext?: boolean;
  className?: string;
}

export const OrderSuspendedAlert: React.FC<OrderSuspendedAlertProps> = ({
  suspensionMessage,
  showWhatNext = true,
  className,
}) => {
  return (
    <div className={clsx('flex justify-center w-full bg-white', className)}>
      <section className="container py-8 pb-5">
        <h1 className="mb-8 text-2xl font-bold font-archivo text-text-primary md:text-3xl">
          Zamówienie wstrzymane
        </h1>

        <div className="relative mt-12">
          {/* PRZYCZYNA: badge */}
          <div className="inline-flex items-center justify-center ml-9 px-[18px] py-2.5 rounded-[5px] bg-blue top-[-20px] absolute">
            <p className="text-[13px] leading-1 font-semibold text-center uppercase text-white">
              Przyczyna:
            </p>
          </div>

          {/* Message card */}
          <div className="flex items-center gap-2.5 px-9 py-7 mt-[-1px] rounded-[15px] bg-primary-200 border border-primary-100">
            <p
              className="flex-grow text-base leading-7 font-inter text-text-primary"
              dangerouslySetInnerHTML={{
                __html:
                  suspensionMessage ||
                  'Twoje zamówienie zostało tymczasowo wstrzymane. Skontaktuj się z nami, aby uzyskać więcej informacji.',
              }}
            />
          </div>

          {/* Green line + CO TERAZ? badge */}
          {showWhatNext && (
            <div className="flex relative flex-col items-start mt-5 ml-9">
              <div className="w-1 h-[105px] ml-[52px] rounded-[50px] bg-green-400 relative" />
              <div className="inline-flex items-center justify-center px-5 py-2.5 rounded-[5px] bg-green -translate-y-1/2 top-1/2 absolute">
                <p className="text-[13px] font-semibold text-center uppercase text-white">
                  Co teraz?
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default OrderSuspendedAlert;
